import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qikbossprnwugyfanyep.supabase.co';
const supabaseKey = 'sb_publishable_NL6yQ5B6Ifxh_FuKf1qokQ_V6yIlkcJ';

export const supabase = createClient(supabaseUrl, supabaseKey);
